import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import 'react-photo-view/dist/react-photo-view.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
